import {
  collectors,
  colsRegister,
  reportLogin,
  reportTrack,
  reportView,
  usePageLeave,
  reportTrackStart,
  reportTrackEnd,
} from './logPack';
import { gpsSendData } from './GPSData';
import { nativeCrawlerMethods } from './nativeCrawlerMethods';
import { pointValidateRegister } from './pointValidate';

export default {
  install: function (Vue, options) {
    if (['development', 'testing'].includes(process.env.NODE_ENV as string)) {
      // 埋点验证工具
      pointValidateRegister(window?.ubs_da);
    }
    // 添加采集器
    collectors.add(window.ubs_da);
    collectors.add(window.Sensors);

    /**
     * 自定义事件上报[命名待更正]
     * 使用方式保持和老项目一致
     * 例如：REPORT_TRACK(event: //string 上报事件名称, data: //object 上报内容对象) {}
     * */
    window.REPORT_TRACK = reportTrack; // 自定义事件
    window.REPORT_TRACK_START = reportTrackStart; // 自定义事件 开始事件
    window.REPORT_TRACK_END = reportTrackEnd; // 自定义事件 结束事件
    /**
     * 展示事件上报
     * 使用方式和老项目一致
     * 例如：REPORT_VIEW.send(data: //object 需要上报的内容)
     * */
    window.REPORT_VIEW = reportView; // 全埋点
    /**
     * 上报方法登录
     */
    window.REPORT_LOGIN = reportLogin;
    /**
     * 和app交互的原生方法
     */
    window.NativeCrawlerMethods = nativeCrawlerMethods;

    /**
     * 反欺诈方法注册
     */
    window.GPS_SENDDATA = gpsSendData;
    // Vue2全局挂载方法
    Vue.prototype.$REPORT_TRACK = reportTrack;
    Vue.prototype.$REPORT_VIEW = reportView;
    Vue.prototype.$REPORT_LOGIN = reportLogin;
    Vue.prototype.$GPS_SENDDATA = gpsSendData;
    // 注册userId
    reportLogin();
    // 所有采集器进行公共注册
    colsRegister();
    usePageLeave();
  },
};
